module.exports = __webpack_public_path__ + "static/media/IMG_20181114_213410_edited.6f767cbc.jpg";